module.exports = __webpack_public_path__ + "img/eg-21-01.89a5d01e.jpg";